import styled, { css } from 'styled-components';

import { Grid, Tabs, Tab, TableRow, TableCell, TableBody } from '@mui/material';

import Button from 'components/Button/styles';

export const ContentInvoice = styled(Grid)`
  color: #627182;
  min-width: 0;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    width: 100%;
    li {
      color: #627182;
      text-transform: uppercase;
      margin: 8px 0;
      label {
        font-weight: bold;
        margin-right: 4px;
      }
    }
  }

  ${({ right }) =>
    right &&
    css`
      text-align: right;
      ul {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
    `}
`;

export const InvoiceRow = styled.div`
  display: flex;
  width: 100%;
  gap: 24px;
  align-items: flex-start;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const InvoiceActionsRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const StyledTabs = styled(Tabs)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  border-bottom: 1px solid ${({ theme }) => theme.colors.background};

  > div {
    overflow: auto !important;

    > span {
      background-color: ${({ theme }) => theme.colors.primary};

      width: 120px;
      height: 3px;
    }
  }
`;

export const StyledTab = styled(Tab).attrs({ disableRipple: true })`
  && {
    min-width: 120px !important;
    color: #627182;
  }

  > span {
    color: #627182;
    font-size: 1rem;
    font-weight: 600;

    ${({ active, theme }) =>
      active &&
      css`
        color: ${theme.colors.primary};
      `}
  }
`;

export const StyledTableBody = styled(TableBody)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.background};
`;

export const StyledTableRow = styled(TableRow)`
  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.background};
  }

  > th,
  td {
    border-bottom: none;

    color: #627182;
    font-weight: 300;

    padding-bottom: 10px;
    padding-top: 10px;
  }
`;

export const StyledTableCell = styled(TableCell)``;

export const CloseButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 10px;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;

  background-color: transparent;
  color: #627182;

  svg {
    color: #627182;

    width: 21px;
    height: 21px;
  }

  span {
    text-transform: uppercase;
  }
`;

export const DocumentsContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.background};

  color: #627182;
  font-size: 1rem;
  font-weight: lighter;

  ${Button} {
    font-size: 0.9rem;

    min-width: 95px;

    &:first-child {
      margin-right: 5px;
    }
  }
`;

export const DocumentCTE = styled.span`
  font-weight: 600;
`;

export const DocumentType = styled.div`
  color: #627182;
  font-size: 1rem;
  font-weight: 400;
  line-height: 18px;

  margin: 10px 0px 10px 5px;
`;

export const DocumentRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 6px;
  }
`;

export const DocumentDate = styled.div`
  color: #627182;
  text-align: center;

  @media (max-width: 900px) {
    text-align: left;
  }
`;

export const DocumentActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 900px) {
    justify-content: flex-start;
  }
`;
